<template>
  <v-card class="nospace transporter-list-card oms-list-table-card">
    <v-card-text class="nospace">
      <v-card-text class="nospace">
        <loading :active.sync="loading" />

        <FilterBoard
          class="transporter-filter-row oms-list-filter"
          eyebrow=""
          title="Transporter directory"
        >
          <template slot="header-actions">
            <button
              v-permissions="'create-transporter'"
              class="oms-action-card-button transporter-add-card"
              type="button"
              @click="check()"
            >
              <span class="oms-action-card-button__icon">
                <v-icon>add</v-icon>
              </span>
              <span class="oms-action-card-button__label">
                Register New Transporter
              </span>
            </button>
          </template>

          <v-flex
            xs12
            sm6
            md3
            class="oms-filter-board__field transporter-filter-field--type"
          >
            <v-select
              v-model="searchTypes"
              :items="searchItems"
              flat
              label="Search Type"
              item-text="status"
              single-line
              class="pt-0"
              item-value="abbr"
              persistent-hint
              @change="searchByType()"
              height="10"
              return-object
              outline
              hide-details
            ></v-select>
          </v-flex>
          <v-flex
            xs12
            sm6
            md4
            class="oms-filter-board__field transporter-filter-field--search"
          >
            <v-text-field
              class="gap"
              label="Search here.."
              outline
              single-line
              :disabled="!searchTypes"
              v-model="search"
              @keyup.enter="searchText"
              @click:append="searchText"
              append-icon="search"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
            class="oms-filter-board__field transporter-filter-field--job"
          >
            <v-select
              label="Transporter Type"
              :items="JobTypes"
              class="pt-0"
              v-model="jobType"
              @change="searchJobType"
              single-line
              hide-details
              outline
            />
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
            class="oms-filter-board__field transporter-filter-field--registered"
          >
            <v-select
              label="Registered As"
              :items="transporterType"
              class="pt-0"
              v-model="type"
              @change="searchCategory"
              single-line
              hide-details
              outline
            />
          </v-flex>

          <v-flex
            xs12
            sm6
            md1
            class="reset-btn oms-filter-board__actions transporter-filter-field--reset"
          >
            <v-card-actions class="justify-center">
              <v-btn
                class="reset-btn-color oms-filter-board__reset"
                flat
                prepend-icon
                color="orange darken-1"
                @click.native="reset()"
              >
                Reset
                <v-icon color="orange">donut_large</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex>
        </FilterBoard>
      </v-card-text>
      <ScrollableTable class="transporter-table-scroll oms-list-table-scroll" min-width="100%">
        <v-data-table
          id="TransporterListTable"
          class="transporter-modern-table oms-list-table"
          hide-actions
          :headers="headers"
          :items="items"
          :disable-initial-sort="true"
          :pagination.sync="pagination"
        >
        <template slot="items" slot-scope="props">
          <td>
            <div class="transporter-dir-id">
              <activityLogs
                :type="'transporter'"
                :id="props.item.transporterId.toString()"
                :_id="props.item._id"
              />
              <span class="transporter-dir-id__number"
                >#{{ props.item.transporterId }}</span
              >
            </div>
            <div class="transporter-dir-pills">
              <span
                v-if="props.item.isVerified"
                class="transporter-dir-pill transporter-dir-pill--green"
                >Verified</span
              >
              <span v-else class="transporter-dir-pill transporter-dir-pill--amber"
                >Not verified</span
              >
              <span
                v-if="props.item.isBlocked"
                class="transporter-dir-pill transporter-dir-pill--red"
                >Blocked</span
              >
            </div>
          </td>
          <td>
            <div class="transporter-dir-primary">
              {{ props.item.companyName || "-" }}
            </div>
            <div class="transporter-dir-secondary">
              {{ props.item.transporterName || "-" }}
            </div>
          </td>
          <td>
            <span class="transporter-dir-country">
              <img
                v-if="countryFlag(props.item.workingCountry)"
                :src="countryFlag(props.item.workingCountry)"
                class="transporter-dir-country__flag"
                :class="{
                  'transporter-dir-country__flag--round':
                    props.item.workingCountry === 'UAE LA',
                }"
                alt=""
              />
              {{ props.item.workingCountry || "-" }}
            </span>
          </td>
          <td>
            <span
              class="transporter-dir-pill"
              :class="`transporter-dir-pill--${getJobType(
                props.item.jobType
              ).toLowerCase()}`"
              >{{ getJobType(props.item.jobType) }}</span
            >
            <div class="transporter-dir-secondary">
              {{ props.item.transporterType || "-" }}
            </div>
          </td>
          <td>
            <div class="transporter-dir-primary">
              {{ formatPhone(props.item) }}
            </div>
            <div class="transporter-dir-secondary">
              {{ props.item.email || "-" }}
            </div>
          </td>
          <td>
            <div class="transporter-dir-primary">
              {{ getDate(props.item.registrationDate) }}
            </div>
            <div class="transporter-dir-secondary">
              {{ getSignupSource(props.item.deviceType) }}
            </div>
          </td>
          <td>
            <div class="transporter-dir-actions">
              <button
                type="button"
                class="transporter-dir-btn transporter-dir-btn--primary"
                title="Details"
                @click="
                  editTransporter(
                    props.item.transporterId,
                    props.item._id,
                    props.item.workingCountry,
                    props.item.isVerified
                  )
                "
              >
                Details
              </button>
              <button
                v-if="props.item.isBlocked"
                v-permissions="'block-transporter'"
                type="button"
                class="transporter-dir-btn transporter-dir-btn--amber"
                title="Unblock"
                :disabled="processing"
                @click="blockCustomer(props.item._id, 'false')"
              >
                Unblock
              </button>
              <button
                v-else
                v-permissions="'block-transporter'"
                type="button"
                class="transporter-dir-btn transporter-dir-btn--danger"
                title="Block"
                :disabled="processing"
                @click="blockCustomer(props.item._id, 'true')"
              >
                Block
              </button>
              <button
                v-if="!props.item.isVerified"
                v-permissions="'verify-transporter'"
                type="button"
                class="transporter-dir-btn transporter-dir-btn--blue"
                title="Verify"
                @click="verifyTransporter(props.item._id, 'true')"
              >
                Verify
              </button>
            </div>
          </td>
        </template>
        </v-data-table>
      </ScrollableTable>
      <pagination
        :totalPages="totalPages"
        :pages="this.pages"
        @pageNo="page"
        :url="`/dmsAdmin/transportList`"
        :callback="callback"
        :componentKey="componentKey"
        :action="`transporter`"
        :payload="payload"
        :type="1"
        v-on:pagination-load="checkLoading"
      />
      <success-dialog
        :content="x.message"
        :show="x.success"
        :onclose="closeMessage"
      />
      <v-snackbar
        :timeout="3000"
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
      <SelectCountry
        :open="selectCountryDialog"
        @closeSelectCountry="selectCountryDialog = false"
        :type="'/transporter/new'"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import _ from "lodash";
import SelectCountry from "../Common/SelectCountry";
import { transporterList } from "@/constants/datatable-headers.js";
import { transporter } from "../../constants/api-urls";
import { EventBus } from "../../event-bus.js";
import activityLogs from "../Common/activityLogs";
import Loading from "vue-loading-overlay";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ErrorBox from "@/components/Common/ErrorBox";
import ScrollableTable from "@/components/Common/ScrollableTable";
import FilterBoard from "@/components/Common/FilterBoard";
import moment from "moment";
import { StorageKeys, JobTypes, JobListTypes } from "../../constants/constants";
import { async } from "q";
import pagination from "@/components/Pagination/pagination";
import uaeFlag from "@/assets/Uaeflag.png";
import ksaFlag from "@/assets/ksaflag.png";
import pakFlag from "@/assets/pakflag.png";
import omanFlag from "@/assets/omanflag.png";

const COUNTRY_FLAGS = {
  UAE: uaeFlag,
  "UAE LA": uaeFlag,
  KSA: ksaFlag,
  PAK: pakFlag,
  OMAN: omanFlag,
};
export default {
  created() {
    this.$eventBus.$on("newtransporters", (value) => {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
        this.componentKey += 1;
      }
    });
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = JSON.stringify(workingCountry);
      this.payload = {
        workingCountry: this.workingCountry,
      };
    }

    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = JSON.stringify(val);
      this.payload.workingCountry = this.workingCountry;
      this.$eventBus.$emit("on-load");
    });

    if (localStorage.getItem("searchTransporter") !== null) {
      this.search = localStorage.searchTransporter;
      let searchTransporterType = JSON.parse(
        localStorage.searchTransporterType
      );
      this.searchTypes = searchTransporterType;
      this.payload = {
        searchText: this.search,
        searchType: this.searchTypes.abbr,
        workingCountry: this.workingCountry,
      };
    }
    if (this.$route.query && this.$route.query.workingCountry) {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry = key.value;
          }
        });
      }

      let key = this.$route.query.workingCountry;
      EventBus.$emit("setCountriesfromUrl", key);
      this.workingCountries.forEach((element, index) => {
        if (element.value === key) {
          element.isSelected = true;
          this.newInquiry = 0;
          this.newJob = 0;
        } else element.isSelected = false;
      });
      localStorage.setItem(
        "workingCountries",
        JSON.stringify(this.workingCountries)
      );
    }
    this.JobTypes = JobTypes;

    if (!navigator.onLine) {
      this.loading = false;
      this.error = "Please check your internet connection";
      setTimeout(() => {
        this.error = "";
      }, 3000);
      return;
    }

    this.$eventBus.$on("stop-load", () => {
      this.loading = false;
    });
  },
  components: {
    pagination,
    SuccessDialog,
    ErrorBox,
    Loading,
    activityLogs,
    SelectCountry,
    ScrollableTable,
    FilterBoard,
  },
  props: {
    loadingstop: Function,
    loader: Boolean,
  },

  data() {
    return {
      transporterType: [
        { value: "Transporter", text: "Transporter" },
        { value: "Broker", text: "Broker" },
      ],
      type: "",
      selectCountryDialog: false,
      workingCountry: null,
      JobTypes: [],
      operations: "",
      operationName: "",
      jobType: "",
      error: "",
      pages: 1,
      loading: true,
      dialog: false,
      dialog2: false,
      processing: false,
      x: {
        message: "",
        loading: true,
        success: false,
        menu: false,

        error: null,
        missingField: null,
      },
      search: "",
      componentKey: 0,
      totalPages: 0,
      pagination: {},

      payload: {},
      searchItems: [
        { status: "Company Name", abbr: "companyName" },
        { status: "Username", abbr: "userName" },
        { status: "Email", abbr: "email" },
        { status: "Phone Number", abbr: "mobileNumber" },
      ],
      searchTypes: "",
      headers: transporterList,
      items: [],
    };
  },
  watch: {
    pagination(val) {
      if (val["sortBy"] === "companyName") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "companyName";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "companyName";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      }
      if (!val["sortBy"]) {
        delete this.payload["sortType"];
        delete this.payload["sortBy"];
        if (val["descending"] == null) {
          this.componentKey = this.componentKey + 1;
        }
      }
      deep: true;
    },
  },
  methods: {
    checkLoading(event) {
      if (event) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    },
    page(event) {
      this.pages = event;
    },

    async check() {
      this.operationName = "create-transporter";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y) {
        if (localStorage.getItem("workingCountries")) {
          this.workingCountries = JSON.parse(
            localStorage.getItem("workingCountries")
          );
          let workingCountry = [];
          this.workingCountries.forEach((key, index) => {
            if (key.isSelected) {
              workingCountry.push(key.value);
            }
          });
          if (workingCountry.length === 1) {
            this.$router.push(`/transporter/new`);
          } else {
            this.selectCountryDialog = true;
          }
        }
      } else {
        return;
      }
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    getDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    countryFlag(country) {
      return COUNTRY_FLAGS[country];
    },
    formatPhone(item) {
      return item.phoneNo != null && item.countryCode != null
        ? `${item.countryCode} ${item.phoneNo}`
        : "-";
    },
    getSignupSource(deviceType) {
      if (deviceType == "ADMIN PANEL") return "Admin Panel";
      if (deviceType == "WEB") return "Transporter Panel";
      return deviceType || "-";
    },
    callback(res) {
      this.items = res.list;
      this.totalPages = Math.ceil(res.totalData / 15);
      this.pagination.rowsPerPage = 15;
      window.scrollTo(0, 0);
    },
    searchByType() {
      //  localStorage.setItem("transporterSerachType", this.searchTypes.abbr);
      this.$emit("filters-type", this.searchTypes.abbr);
      this.search = "";
      this.searchText();
    },
    searchCategory() {
      if (this.type) {
        // localStorage.setItem("transporterTypeFilter", this.type);
        this.$set(this.payload, "transporterType", this.type);
      }
    },
    searchJobType() {
      if (this.jobType) {
        //  localStorage.setItem("transporterJobType", this.jobType);
        this.$set(this.payload, "jobType", this.jobType);
      }
    },
    searchText: function () {
      //  localStorage.setItem("transporterSearch", this.search);
      if (this.search.trim() != "") {
        this.payload.searchType = this.searchTypes.abbr;

        this.$set(this.payload, "searchText", this.search);
      } else {
        delete this.payload.searchText;
        this.componentKey++;
      }
    },

    editTransporter(id, _id, country, isVerified) {
      this.$router.push(
        `/transporter/edit/${id}/${_id}/${country}/${isVerified}`
      );
    },

    paginationPayload(event) {
      this.payload = event;
      this.loading = true;
    },
    reset() {
      // localStorage.removeItem("searchTransporter");
      // localStorage.removeItem("transporterSerachType");
      // localStorage.removeItem("transporterTypeFilter");
      // localStorage.removeItem("transporterJobType");

      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      if (this.search.trim() || this.jobType || this.type) {
        this.searchTypes = "";
        this.search = "";
        this.jobType = "";
        this.type = "";
        this.loading = true;
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },

    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.$emit("on-block");
    },
    verifyTransporter(id, status) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        let blockUrl = transporter.verifyTender;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        let body = {
          transporterId: id.toString(),

          isVerified: status,
        };
        this.axios.post(this.constants.apiUrl + blockUrl, body, config).then(
          (response) => {
            this.x.success = true;
            this.processing = false;
          },
          (error) => {
            this.x.success = false;
            this.error = error.response.data.message;
          }
        );
      }
    },
    async blockCustomer(id, status) {
      this.operationName = "block-transporter";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y) {
        if (!navigator.onLine) {
          this.loading = false;
          this.error = "Please check your internet connection";
          setTimeout(() => {
            this.error = "";
          }, 3000);
          return;
        }
        if (this.processing) {
          return;
        } else {
          this.processing = true;
          let blockUrl = transporter.blockTransporter;
          delete this.axios.defaults.headers.common["token"];
          let token = localStorage.getItem(StorageKeys.SessionKey);
          let config = {
            headers: {
              authorization: `bearer ${token}`,
            },
          };

          let body = {
            transporterId: id.toString(),

            isBlocked: status,
          };
          this.axios.post(this.constants.apiUrl + blockUrl, body, config).then(
            (response) => {
              this.x.success = true;
              this.processing = false;
            },
            (error) => {
              this.x.success = false;
              this.x.error = error.response.data.message;
            }
          );
        }
      } else {
        return;
      }
    },
  },
};
</script>
<style lang="scss">
#TransporterListTable
  .theme--light.v-datatable
  thead
  th.column.sortable
  .v-icon {
  opacity: 0.3 !important;
  color: white !important;
  margin-left: 10px !important;
}
#TransporterListTable
  .theme--light.v-datatable
  thead
  th.column.sortable.active
  .v-icon {
  opacity: 1 !important;
  color: white !important;
  margin-left: 10px !important;
}
.table-header-item1 {
  font-size: 16px !important;
  color: orange;
  font-weight: bold;
}
.red-text2 {
  color: red;
  animation: animate 1.5s linear infinite;
}
</style>

<style scoped>
.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
}

#nav .transporter-modern-table .transporter-dir-id {
  align-items: center;
  display: inline-flex;
  gap: 0.375rem;
  justify-content: center;
}

#nav .transporter-modern-table .transporter-dir-id__number {
  color: var(--oms-ink-strong, #1a1916);
  font-size: 0.8125rem;
  font-weight: 700;
  white-space: nowrap;
}

#nav .transporter-modern-table .transporter-dir-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  justify-content: center;
  margin-top: 0.3125rem;
}

#nav .transporter-modern-table .transporter-dir-pill {
  align-items: center;
  border: 0.0625rem solid transparent;
  border-radius: 999px;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.65625rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1;
  padding: 0.1875rem 0.5rem;
  white-space: nowrap;
}

#nav .transporter-modern-table td:first-child .transporter-dir-pill {
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

#nav .transporter-modern-table .transporter-dir-pill--green {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

#nav .transporter-modern-table .transporter-dir-pill--amber {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

#nav .transporter-modern-table .transporter-dir-pill--red {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

#nav .transporter-modern-table .transporter-dir-pill--land {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

#nav .transporter-modern-table .transporter-dir-pill--air {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

#nav .transporter-modern-table .transporter-dir-pill--sea {
  background: #ecfeff;
  border-color: #a5f3fc;
  color: #0e7490;
}

#nav .transporter-modern-table .transporter-dir-primary {
  color: var(--oms-ink-strong, #1a1916);
  font-weight: 600;
}

#nav .transporter-modern-table .transporter-dir-secondary {
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  margin-top: 0.1875rem;
}

#nav .transporter-modern-table .transporter-dir-country {
  align-items: center;
  color: var(--oms-ink-strong, #1a1916);
  display: inline-flex;
  font-weight: 600;
  gap: 0.375rem;
  white-space: nowrap;
}

#nav .transporter-modern-table .transporter-dir-country__flag {
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem rgba(26, 25, 22, 0.08);
  height: 0.875rem;
  width: auto;
}

#nav .transporter-modern-table .transporter-dir-country__flag--round {
  border-radius: 50%;
  object-fit: cover;
  width: 0.875rem;
}

#nav .transporter-modern-table .transporter-dir-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  justify-content: center;
}

#nav .transporter-modern-table .transporter-dir-btn {
  align-items: center !important;
  background: #ffffff;
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.4375rem !important;
  box-shadow: none;
  cursor: pointer;
  display: inline-flex !important;
  font-size: 0.6875rem !important;
  font-weight: 700;
  height: 1.75rem;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 1.75rem;
  padding: 0 0.625rem !important;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  white-space: nowrap !important;
}

#nav .transporter-modern-table .transporter-dir-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

#nav .transporter-modern-table .transporter-dir-btn--primary {
  background: var(--oms-primary, #ea7a1c);
  border-color: var(--oms-primary, #ea7a1c);
  color: #ffffff;
}

#nav .transporter-modern-table .transporter-dir-btn--primary:hover {
  background: #d96a10;
  border-color: #d96a10;
}

#nav .transporter-modern-table .transporter-dir-btn--danger {
  border-color: #fecaca;
  color: #b91c1c;
}

#nav .transporter-modern-table .transporter-dir-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
}

#nav .transporter-modern-table .transporter-dir-btn--amber {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

#nav .transporter-modern-table .transporter-dir-btn--amber:hover:not(:disabled) {
  background: #fef3c7;
}

#nav .transporter-modern-table .transporter-dir-btn--blue {
  border-color: #bfdbfe;
  color: #1d4ed8;
}

#nav .transporter-modern-table .transporter-dir-btn--blue:hover {
  background: #eff6ff;
}
</style>
